export default {
  titleFirst: {
    en: 'Congratulations!',
  },
  textFirst: {
    en: `
    Your first product has been added to the queue.<br/>
    <b>
      As soon as you complete your subscription,<br />
      we'll ship your order straight to your door!
    </b>
  `,
  },

  titleSecond: {
    en: 'Hey there!',
  },
  textSecond: {
    en: `
    We have noticed that you added another product to your queue.<br />
    <b>
      Just to let you know: as soon as you complete your subscription,<br />
      we'll ship your order straight to your door!
    </b>
  `,
  },

  buttonSubscribe: {
    en: 'Subscribe',
  },
  buttonClose: {
    en: 'Close',
  },
}
